/**
 * Побочные импорты: регистрация страниц через registerPageInit.
 * Порядок не важен.
 */
import '../pages/404-page';
import '../pages/500-page';
import '../pages/about-construction';
import '../pages/about-documents';
import '../pages/about-faq';
import '../pages/about-fund';
import '../pages/about-team';
import '../pages/about';
import '../pages/clusters';
import '../pages/cluster-lomonosov-infrastructure';
import '../pages/education-management';
import '../pages/education-permission';
import '../pages/education-programs';
import '../pages/index';
import '../pages/infrastructure';
import '../pages/manager-report-form';
import '../pages/manager-requests';
import '../pages/event-detail';
import '../pages/news-activity-page';
import '../pages/news-detail';
import '../pages/news-events-calendar';
import '../pages/news-feed';
import '../pages/news-page';
import '../pages/personal-area';
import '../pages/personal-manager-area';
import '../pages/personal-manager-residents-area';
import '../pages/politika';
import '../pages/recover-password-form';
import '../pages/reminder-for-residents';
import '../pages/report-form';
import '../pages/reservation';
import '../pages/residency-become';
import '../pages/residency';
import '../pages/vue-example';
